// Dor de cabeça/Cefaleia; -> 800
// Dor nas costas (Lombalgia); -> 610
// Renovação Receita; -> 222
// Dor no estômago (Refluxo). -> 611

export const ONLY_TELEMEDICINE_SPECIALTIES_CODE = ['800', '610', '222', '611'];
